import styled from "styled-components";
export const M1 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
`;
export const M2 = styled.div`
  background-color: #f6f7f9;
  border-radius: 8px;
  padding: 5px;
  width: 60%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #353a50;
`;
// export const M3 = styled.div``
export const M3 = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #353a50;
`;
export const M4 = styled.div`
  text-align: center;
  background-color: #2a2e43;
  margin: 20px 10px;
  border-radius: 12px;
  padding: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
`;
export const M5 = styled.div`
  background-color: #f6f7f9;
  margin: 10px;
  padding: 10px;
  border-radius: 12px;
  text-align: right;
`;
export const M6 = styled.div`
  text-align: center;
  background-color: #2a2e43;
  margin: 10px;
  border-radius: 12px;
  padding: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
`;
export const M7 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;
export const M8 = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
`;
export const M9 = styled.div`
  background-color: #2a2e43;
  padding: 8px;
  border-radius: 12px;
  width: 20%;
  text-align: center;
  color: #fff;
  margin: 10px;
  cursor: pointer;
`;
export const M10 = styled.div`
  background-color: #f6f7f9;
  padding: 8px;
  border-radius: 12px;
  width: 20%;
  text-align: center;
  margin: 10px;
  cursor: pointer;
`;
